import React, { useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner,
  CAlert,
} from '@coreui/react'
import Constant from '../../../_utils'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'

const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  function setToken(userToken) {
    localStorage.setItem('token', userToken)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    event.stopPropagation()

    setLoading(true)

    const form = event.currentTarget
    if (form.checkValidity() === false) {
      return
    }

    fetch(`${Constant.API_URL}/users/login`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ Username: username, pass: password }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.IsUser) {
            setToken(JSON.stringify(result))
            setError(false)
            window.location.reload()
          } else {
            setError(true)
          }
          setLoading(false)
        },
        (error) => {
          console.log(error)
          setLoading(false)
        },
      )
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="4">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  {error ? <CAlert color="danger">Usuario o Password equivocado...</CAlert> : <></>}
                  <CForm onSubmit={handleSubmit}>
                    <h1>Acceso PIME</h1>
                    <p className="text-medium-emphasis">Accede al sistema</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="Usuario"
                        autoComplete="username"
                        required
                        onChange={(event) => {
                          setUsername(event.target.value)
                        }}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        required
                        onChange={(event) => {
                          setPassword(event.target.value)
                        }}
                      />
                    </CInputGroup>
                    <CRow className="">
                      <CCol xs="12">
                        <CButton type="submit" color="primary">
                          {loading ? (
                            <>
                              <CSpinner size="sm" /> <span>Entrando ...</span>
                            </>
                          ) : (
                            <span>Entrar</span>
                          )}
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
